
import { AbstractIcon } from './abstract';
import { componentsRegistryService } from 'cruzo';

export class TeamIcon extends AbstractIcon {
  static selector = "team-icon"

  getHTML() {
    return `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
        viewBox="0 0 64 64" xml:space="preserve">
        <path style="stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;" d="
          M20,47.08c0-2.311-1.515-3.63-3.25-4.16c-1.451-0.443-6.655-0.435-6.655-6.72c0-1.846,1.552-3.2,3.56-3.2
          c3.405,0,3.405,3.52,3.405,3.52c0,4.197-2.791,5.44-6.563,6.4C8.568,43.41,7,44.72,7,46.44V51h36v-4.56
          c0-1.72,1.568-3.03,3.496-3.52c3.772-0.96,6.563-2.203,6.563-6.4c0,0,0-3.52-3.405-3.52c-2.008,0-3.56,1.354-3.56,3.2
          c0,6.285,5.204,6.277,6.655,6.72c1.735,0.53,4.25,1.849,4.25,4.16c0,0,0-20.08,0-20c0-2.311-2.515-3.63-4.25-4.16
          c-1.451-0.443-6.655-0.435-6.655-6.72c0-1.846,1.552-3.2,3.56-3.2c3.405,0,3.405,3.52,3.405,3.52c0,4.197-2.791,5.44-6.563,6.4
          C44.568,23.41,42,24.72,42,26.44V29v6c0,1.105-0.895,2-2,2h0c-1.105,0-2-0.895-2-2v-1.92c0-2.311-1.515-3.63-3.25-4.16
          c-1.451-0.443-6.655-0.435-6.655-6.72c0-1.846,1.552-3.2,3.56-3.2c3.405,0,3.405,3.52,3.405,3.52c0,4.197-2.791,5.44-6.563,6.4
          C26.568,29.41,25,30.72,25,32.44V35c0,1.105-0.895,2-2,2h0c-1.105,0-2-0.895-2-2v-7.92c0-2.311-1.515-3.63-3.25-4.16
          c-1.451-0.443-6.655-0.435-6.655-6.72c0-1.846,1.552-3.2,3.56-3.2c3.405,0,3.405,3.52,3.405,3.52c0,4.197-2.791,5.44-6.563,6.4
          C9.568,23.41,8,24.72,8,26.44V29"/>
        </svg>`;
  }
}

componentsRegistryService.define(TeamIcon);